import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "./views/LoginPage";
import HomePage from "./views/HomePage";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectLanguage from "./views/SelectLanguage";
import Customer from "./views/Customer";
import CustomerInfo from "./views/CustomerInfo";
import MonthReport from "./views/MonthlyReport";
import DailyReport from "./views/DailyReport";
import MoreOptions from "./views/MoreOptions";
import AreaWiseReport from "./views/AreaWiseReport";
import SubscriptionExpiryReport from "./views/SubscriptionExpiryReport";
import CollectPayment from "./views/CollectPayment";
import CustomerStatistics from "./views/CustomerStatistics";
import PrivateRoutes from "./components/PrivateRoutes";
import Complaints from "./views/Complaints";
import Print from "./views/Print";
import PaymentHistory from "./views/PaymentHistory";
import HistoryVisit from "./views/HistoryVisit";
import RecordVisit from "./views/RecordVisit";
import EditCustomer from "./views/EditCustomer";
import EditSetTopBox from "./views/EditSetTopBox";
import AddCustomer from "./views/AddCustomer";

import EditSingleBox from "./views/EditSingleBox";
import STBListing from "./views/STBListing";

import ADDSTBListing from "./views/ADDSTBListing";
import Renewal_STBListing from "./views/Renewal_STBListing";
import STBHistory from "./views/STBHistory";
import BarCodeScanner from "./views/BarCodeScanner";
import RegisterComplaints from "./views/RegisterComplaints";
import AddChannel from "./views/AddChannel";
import MutipleAddChannel from "./views/Mutiple_AddChannel";
import RenewChannel from "./views/RenewChannel";
import MultiStbRenewChannel from "./views/MultiStbRenewChannel";
import SelectedPacks from "./views/SelectedPacks";
import MultiStbSelectedPacks from "./views/MultiStbSelectedPacks";
function App() {
  window.addEventListener("online", handleConnection);
  window.addEventListener("offline", handleConnection);

  function handleConnection() {
    if (navigator.onLine) {
      console.log("Online");
    } else {
      console.log("Offline");
      window.location.reload();
    }
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/addcustomer" element={<AddCustomer />} />
          <Route path="/select" element={<SelectLanguage />} />
          <Route path="/home" element={<HomePage />} />
          {/* <Route path="/customer" element={<Customer />} /> */}
          <Route path="/customerDrawer" element={<customerDrawer />} />
          <Route path="/monthlyReport" element={<MonthReport />} />
          <Route path="/dailyReport" element={<DailyReport />} />
          <Route path="/more" element={<MoreOptions />} />
          <Route path="/areaWiseReport" element={<AreaWiseReport />} />
          <Route
            path="/subExpiryReport"
            element={<SubscriptionExpiryReport />}
          />
          <Route path="/customerStatistics" element={<CustomerStatistics />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/customerInfo" element={<CustomerInfo />} />
          <Route path="/print" element={<Print />} />
          <Route path="/customer/*">
            <Route index element={<Customer />} />
            <Route path="collectPayment">
              <Route index element={<CollectPayment />} />
              <Route path="history">
                <Route index element={<PaymentHistory />} />
              </Route>
              <Route path="recordVisit">
                <Route index element={<RecordVisit />} />
                <Route path="historyVisit" element={<HistoryVisit />} />
              </Route>
              <Route path="editCustomer" element={<EditCustomer />} />
              <Route path="STBlisting">
                <Route index element={<STBListing />} />
              </Route>
              <Route path="ADDSTBListing">
                <Route index element={<ADDSTBListing />} />
              </Route>
              <Route path="Renewal_STBListing">
                <Route index element={<Renewal_STBListing />} />
              </Route>
              <Route path="editSetTopBox">
                <Route index element={<EditSetTopBox />} />
                <Route path="barCodeScanner" element={<BarCodeScanner />} />
              </Route>
              <Route path="EditSingleBox">
                <Route index element={<EditSingleBox />} />
                <Route path="barCodeScanner" element={<BarCodeScanner />} />
              </Route>
              <Route
                path="registerComplaints"
                element={<RegisterComplaints />}
              />
              <Route path="addChannel" element={<AddChannel />} />
              <Route path="Mutiple_AddChannel">
                <Route index element={<MutipleAddChannel />} />
              </Route>
              <Route path="renewChannel">
                <Route index element={<RenewChannel />} />
                <Route path="selectedPacks" element={<SelectedPacks />} />
              </Route>
              <Route path="MultiStbRenewChannel">
                <Route index element={<MultiStbRenewChannel />} />
                <Route
                  path="MultiStbSelectedPacks"
                  element={<MultiStbSelectedPacks />}
                />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="/" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
